module.exports = __webpack_public_path__ + "static/zen_maroon-5067fe8c91b93381ebd30befe9297be3.png";